import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import i18n, { SUPPORTED_LANGUAGES } from "../i18n/i18n";

const LanguageSync = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const lang = params.get("language");
    const resolved =
      lang && SUPPORTED_LANGUAGES.includes(lang) ? lang : "en";
    if (i18n.language !== resolved) {
      i18n.changeLanguage(resolved);
    }
  }, [location.search]);

  return children;
};

export default LanguageSync;
